import Service from './api.service';

export default class RestResource {
  constructor(resource) {
    this.resource = `/${resource}`;
    this.parents = [];
  }

  get(params = {}) {
    return Service.get(this.getResource(), { params: params }).catch(this.handleErrors);
  }

  show(id, params = {}) {
    return Service.get(this.getResource({ id: id }), { params: params }).catch(this.handleErrors);
  }

  create(payload, params = {}) {
    return Service.post(this.getResource(), this.map(payload), { params: params }).catch(this.handleErrors);
  }

  attach(id, payload, params = {}) {
    return Service.put(this.getResource({ id: id }), this.mapAttach(payload), { params: params }).catch(
      this.handleErrors
    );
  }

  update(id, payload, params = {}) {
    return Service.patch(this.getResource({ id: id }), this.map(payload), { params: params }).catch(this.handleErrors);
  }

  delete(id, payload = {}) {
    return Service.delete(this.getResource({ id: id }), { data: payload }).catch(this.handleErrors);
  }

  /** Build resource url*/
  getResource(params = {}) {
    let route = this.resource;
    if (this.parents.length > 0) {
      for (let p = 0; p < this.parents.length; p++) {
        route = route.replace(`$${p}`, this.parents[p]);
      }
    }
    if (params.hasOwnProperty('id')) {
      return `${route}/${params.id}`;
    }

    return route;
  }

  /** Download PDFs */
  pdfResource(id) {
    return `${this.resource}/${id}/pdf`;
  }

  downloadPDF(response, filename) {
    let blob = new Blob([response.data], { type: 'application/pdf' });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    link.remove();
  }

  /** Map data to server */
  map(payload) {
    return payload;
  }

  mapAttach(payload) {
    return payload;
  }

  /** Handle errors */
  handleErrors(err) {
    if (err.response && err.response.status === 422) {
      return RestResource.errUnprocessableEntity(err);
    }
    return Promise.reject(err);
  }

  handleMethod(method, params) {
    return RestResource.resolve(this[method](params));
  }

  static resolve(promise) {
    return promise.then((data) => [data, undefined]).catch((error) => Promise.resolve([undefined, error]));
  }

  // Error 422
  static errUnprocessableEntity(err) {
    let errObj = err.response.data.errors;
    let errors = [];
    for (let prop in errObj) {
      if (errObj.hasOwnProperty(prop)) {
        errors.push(errObj[prop][0]);
      }
    }
    return Promise.reject(errors.length > 0 ? errors : err);
  }
}
